var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshopsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.117 3.607H2.738a.87.87 0 01-.869-.87.87.87 0 01.869-.868h17.38a.87.87 0 01.868.869.87.87 0 01-.869.869zm-.873 10.862c0 .24-.195.435-.435.435H4.037a.435.435 0 01-.435-.435V4.476h15.642v9.993zM20.117 1H2.737A1.74 1.74 0 001 2.738a1.74 1.74 0 001.733 1.738v9.993c0 .719.585 1.304 1.304 1.304h6.956v1.94L7.276 20.19a.434.434 0 10.481.723l3.236-2.157v1.796a.435.435 0 00.87 0v-1.795l3.234 2.156a.433.433 0 10.482-.723l-3.717-2.477v-1.94h6.947c.72 0 1.304-.585 1.304-1.304V4.476h.004a1.74 1.74 0 001.738-1.738A1.74 1.74 0 0020.117 1z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.117 3.607H2.738a.87.87 0 01-.869-.87.87.87 0 01.869-.868h17.38a.87.87 0 01.868.869.87.87 0 01-.869.869zm-.873 10.862c0 .24-.195.435-.435.435H4.037a.435.435 0 01-.435-.435V4.476h15.642v9.993zM20.117 1H2.737A1.74 1.74 0 001 2.738a1.74 1.74 0 001.733 1.738v9.993c0 .719.585 1.304 1.304 1.304h6.956v1.94L7.276 20.19a.434.434 0 10.481.723l3.236-2.157v1.796a.435.435 0 00.87 0v-1.795l3.234 2.156a.433.433 0 10.482-.723l-3.717-2.477v-1.94h6.947c.72 0 1.304-.585 1.304-1.304V4.476h.004a1.74 1.74 0 001.738-1.738A1.74 1.74 0 0020.117 1z",
    stroke: "#FFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.487 7.928L12.96 9.69l-2.474 1.762V7.928zm-.535 4.56a.366.366 0 00.38-.027l3.474-2.473a.367.367 0 000-.597l-3.473-2.473a.367.367 0 00-.58.299v4.946c0 .137.077.263.199.325z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.487 7.928L12.96 9.69l-2.474 1.762V7.928zm-.535 4.56a.366.366 0 00.38-.027l3.474-2.473a.367.367 0 000-.597l-3.473-2.473a.367.367 0 00-.58.299v4.946c0 .137.077.263.199.325z",
    stroke: "#FFF",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopsIcon);
export default __webpack_public_path__ + "static/media/workshops-icon.4c3cf6d9.svg";
export { ForwardRef as ReactComponent };